import {
  dispatch,
  updateSearchParameterInStore,
  updateSearchKey,
  updateShowSearchWindow,
} from '@zonofi/zono-money-store';

export const updateSearchParameter = (
  parameterId: string,
  value: string,
  updateSearchValue?: string | string[]
) => {
  dispatch(
    updateSearchParameterInStore({
      parameterId,
      value,
      updateSearchValue: updateSearchValue || '',
    })
  );
  dispatch(updateSearchKey(value));
};

export const onSearchCancel = () => {
  dispatch(
    updateSearchParameterInStore({
      parameterId: '',
      value: '',
      updateSearchValue: '',
    })
  );
  dispatch(updateShowSearchWindow(false));
  dispatch(updateSearchKey(''));
};
